// Radha — which build am I actually looking at?
//
// Exists because a cached page and a current page were indistinguishable on
// screen, which turned a two-minute question into a long exchange. The stamp is
// baked in at build time (vite.config define), so a stale page shows a stale
// stamp and the argument ends. Also on window.__RADHA_BUILD for the console.
import React from "react";

export const BUILD = { stamp: __BUILD_STAMP__, sha: __BUILD_SHA__ };

if (typeof window !== "undefined") {
  (window as unknown as Record<string, unknown>).__RADHA_BUILD = BUILD;
}

/** Settings is a long page; these are the sections below the fold. */
const JUMPS: Array<[string, string]> = [
  ["erp-sync", "ERP sync (Zoho Books)"],
  ["digests", "Digests"],
  ["enterprise", "Enterprise"],
];

export function BuildStamp() {
  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap",
      padding: "7px 10px", marginBottom: 18, borderRadius: 8,
      background: "var(--surface-2)", fontSize: 11.5, color: "var(--fg-muted)",
    }}>
      <span title="Baked in when this bundle was built. If it looks old, the page is cached.">
        Build <strong style={{ color: "var(--fg)" }}>{BUILD.stamp}</strong> · {BUILD.sha}
      </span>
      <span style={{ marginInlineStart: "auto", display: "flex", gap: 8, flexWrap: "wrap" }}>
        {JUMPS.map(([id, label]) => (
          <button key={id} onClick={() => go(id)}
            style={{ padding: "1px 7px", fontSize: 11, border: "1px solid var(--border)", borderRadius: 5, background: "none", color: "var(--fg-muted)", cursor: "pointer" }}>
            {label} ↓
          </button>
        ))}
      </span>
    </div>
  );
}
